module.exports = __webpack_public_path__ + "static/img/200264.aceb2eb9.png";